export default {
  AuditLog: {
    Interval: 'Khoảng thời gian',
    ActivityLog: 'Nhật ký hoạt động',
    FromDate: 'Đến ngày',
    ToDate: 'Từ ngày',
    TimeRecording: 'Thời gian ghi nhận',
    Action: 'Hành động',
    Description: 'Mô tả chi tiết',
    TextSearch: 'Nhập từ khóa để tìm kiếm'
  }
}
